import { IStoreRootState } from "@/store/interface";
import { ActionTree } from "vuex";
import { $getPaymentRequirementsHistory } from "../../api/history/payment-requirements-history";
import { PaymentRequirementsHistoryItem } from "../../api/history/payment-requirements-history.interface";
import { PaymentRequirementsHistoryAction, PaymentRequirementsHistoryGetter, PaymentRequirementsHistoryMutation } from "./constants";
import { PaymentRequirementsHistoryLoaderPayload, PaymentRequirementsHistoryState } from "./interface";

export default <ActionTree<PaymentRequirementsHistoryState, IStoreRootState>> {

	async [PaymentRequirementsHistoryAction.loadHistoryList](
		{ commit, getters },
		payload?: PaymentRequirementsHistoryLoaderPayload
	): Promise<PaymentRequirementsHistoryItem[]> {
		commit(PaymentRequirementsHistoryMutation.setHistoryListLoading, true);

		const historyList = await $getPaymentRequirementsHistory(
			getters[PaymentRequirementsHistoryGetter.historyFilters]
		);

		commit(
			payload?.append
				? PaymentRequirementsHistoryMutation.appendHistoryList
				: PaymentRequirementsHistoryMutation.setHistoryList,
			historyList
		);
		commit(PaymentRequirementsHistoryMutation.setHistoryListLoading, false);

		return historyList;
	},

	async [PaymentRequirementsHistoryAction.loadNextHistoryList](
		{ dispatch, commit, getters }
	): Promise<PaymentRequirementsHistoryItem[]> {
		if (getters[PaymentRequirementsHistoryGetter.historyPageIsEnd]
			|| getters[PaymentRequirementsHistoryGetter.historyListLoading])
			return getters[PaymentRequirementsHistoryGetter.historyList];

		const currentPage = getters[PaymentRequirementsHistoryGetter.historyFilters]
			.pageNumber || 0;

		const queryHistoryCount = getters[PaymentRequirementsHistoryGetter.historyFilters]
			.elementsOnPage;

		commit(PaymentRequirementsHistoryMutation.setHistoryFilters, {
			pageNumber: currentPage + 1
		});

		const historyList = await dispatch(
			PaymentRequirementsHistoryAction.loadHistoryList,
			{ append: true } as PaymentRequirementsHistoryLoaderPayload
		);

		commit(
			PaymentRequirementsHistoryMutation.setHistoryPageIsEnd,
			queryHistoryCount > historyList.length
		);

		return historyList;
	}

}